import { render, staticRenderFns } from "./AppDevelopment.vue?vue&type=template&id=e5877a02&"
import script from "./AppDevelopment.vue?vue&type=script&lang=js&"
export * from "./AppDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports